import {useEffect, useState} from "react";
import {getKickLivestream} from "@/components/DownloaderApp/kick";
import {Bold} from "@/components/DownloaderApp/Bold";
import {useModal} from "@/components/DownloaderApp/Modal";
import {showUpsellModal} from "@/components/DownloaderApp/UpsellPopup";


export function getSubsOnlyVodsByChannel(channelSlug) {
    return getKickLivestream(channelSlug).then(channel => channel.previous_livestreams.filter(ls => ls.video.status === "subscriber_only")).catch(() => ([]))
}

export default function SubOnlyContentAvailable({channelSlug}) {
    const [total, setTotal] = useState()
    const [username, setUsername] = useState('')
    const {show} = useModal();

    useEffect(() => {
        getSubsOnlyVodsByChannel(channelSlug).then(subOnlyLs => {
            setUsername(channelSlug);
            setTotal(subOnlyLs.length)
        })
    }, []);

    function onClick(e) {
        e.preventDefault();
        showUpsellModal(show, {
            source: 'subtitle-note',
            isExternal: true
        })
    }

    if (total === undefined) return null;

    return (
        <span className={"text-sm text-center"}>
            <Bold>{username}</Bold> has also
                   <a className={"underline underline-offset-4"} target={"_blank"}
                      href={`https://kick.com/${channelSlug}/videos?sort=date`}>
            <Bold> {total} 'Subscribers-Only' </Bold> VODs.
        </a>
            <br/>Click <a
            className={"underline underline-offset-4"} onClick={onClick}
            href=""><Bold>here</Bold></a> to download them all!
        </span>
    )
}